<template>
  <div>
    <el-card>
      <el-form ref="form" style="width: 500px" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="用户账号" prop="userName">
          <el-input v-model="form.userName"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassWord">
          <el-input v-model="form.newPassWord"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitFn">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { chat_post, toForm } from '@/api'
export default {
  data() {
    return {
      form: {
        userName: '',
        newPassWord: ''
      },
      rules: {
        userName: [
           { required: true, message: '请输入用户账号', trigger: 'blur' }
        ],
        newPassWord: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 6, message: '密码不能少于6个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitFn() {
      this.$refs.form.validate((valid) => {
          if (valid) {
            this.$confirm( `确定重置当前用户的密码吗？`, '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              let params = toForm({
                ...this.form
              })
              chat_post('admin/v1/restPwd', params, res => {
                if(res.data.MessageContent == 'ok') {
                  this.$message.success('成功')
                  this.form = {
                    userName: '',
                    newPassWord: ''
                  }
                }
              })
            })
          }
      })
    }
  }
}
</script>

<style>

</style>